import { render, staticRenderFns } from "./Boing.vue?vue&type=template&id=4f53aad0&scoped=true&"
import script from "./Boing.vue?vue&type=script&lang=js&"
export * from "./Boing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53aad0",
  null
  
)

export default component.exports